/* Reviews block - full list, loaded from Judge.me.

   blocks/shaped-reviews.liquid server-renders the first few cards from the
   judgeme.review_widget_data metafield, so something useful shows with
   JavaScript off. But that metafield only ever holds page one of ONE product
   (5 reviews), and Judge.me orders it verified-first - which is why imported,
   unverified reviews never appeared.

   This script replaces those cards with the complete list:
     - every product id in data-sr-config (the current product plus its other
       colourways, matched by the block on the title before the "|"),
     - fetched from Judge.me's public storefront endpoint, reviews_for_widget,
       which needs no API token and allows cross-origin reads,
     - merged, de-duplicated and sorted newest first,
     - filtered to reviews rated at least cfg.min for display,
     - cfg.first shown straight away, then cfg.per more per "Show more".

   Phones use their own counts (cfg.firstM / cfg.perM): the grid is one column
   there, so six cards is a long scroll before anything else on the page.

   The endpoint's reviews are NOT shaped exactly like the metafield's: it sends
   body_html only, with no plain-text body field (checked 16 Sep 2026). The
   text is taken from body_html via an inert DOMParser document - it never
   runs scripts or loads anything - and written with textContent.

   18 Sep 2026:
     - Every card shows the Verified tick. Judge.me sets verified_buyer only
       where it can match an order; showing it on some cards and not others
       read as though the rest were doubtful.
     - Each card names the colourway it is about, with its photo. Reviews are
       merged across Midnight, Cocoa and Almond, so the card has to say which.
       Names come from the .sr-products JSON the block emits, keyed by the
       product id the review was fetched under.
     - "Show fewer" appears once "Show more" has been used, and collapsing
       returns to the first batch and scrolls back to the top of the section.

   23 Sep 2026:
     - Merchant replies render under the review, from reply_content and
       shop_reply_name, which the endpoint already sent and the cards simply
       never drew.
     - REPLIES, below, overrides that text per review. See the note there:
       the point is to answer the old "size up" reviews without Judge.me
       emailing those customers again.
     - Reply styles are injected from this file rather than added to
       blocks/shaped-reviews.liquid, so the 24KB block stays untouched.

   24 Sep 2026 - the headline and the histogram disagreed.
     The block server-renders the score and the count from the SHOP-WIDE
     Judge.me metafields (4.84 across 230 reviews), while rebuildHistogram()
     built the bar chart beside it from this product's own reviews. On the
     fajas, which hold five reviews between all four of them and all of them
     five star, the page showed 4.84 next to a chart reading 100% five star.
     applySummary() now writes the score, the stars, the count and the rating
     line up beside the price from the SAME merged list the histogram uses, so
     the two can never drift apart again. The shop-wide numbers still render
     first and are replaced once the fetch lands, which keeps something
     sensible on screen with JavaScript off.

   The star histogram is rebuilt from ALL fetched reviews, including the ones
   the minimum-rating filter hides, so the breakdown stays honest.

   If any request fails, the server-rendered cards are left untouched and the
   button stays hidden.
*/
(function () {
  'use strict';

  var ENDPOINT = 'https://judge.me/reviews/reviews_for_widget';
  var PER_REQUEST = 30;   // the endpoint caps per_page at 30
  var MAX_PAGES = 20;
  var MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var parser = typeof DOMParser !== 'undefined' ? new DOMParser() : null;

  /* Replies written here instead of in Judge.me admin.

     Posting a reply in Judge.me emails the reviewer. All three of these
     customers were dealt with months ago, so a reply typed there now would
     send them a fresh email about a closed problem. Written here, the reply
     shows on the storefront and Judge.me never knows.

     Keyed by the review's Judge.me uuid, which is stable and unique - two of
     these reviewers would otherwise be hard to key on (one posted anonymously,
     and two of the reviews are a fortnight apart).

     A reply NEVER greets a reviewer who posted anonymously by name. Judge.me
     shows the shop the name behind an anonymous review, but the shopper chose
     not to publish it, and this file is served publicly - so the name must not
     appear in the reply text or in these comments.

     Two of these already carry an older Judge.me reply offering an exchange;
     the text here replaces it on the storefront, because what the next shopper
     needs to know is that the garment itself changed, not that this customer
     could return hers. The old replies still stand in Judge.me.

     Savannah's says the exchange was organised, because it was - the point of
     naming it is that a shopper reading a bad-fit review sees the shop sorted
     her out. Do not copy that sentence onto a review where it did not happen.

     Trade-off: these live in the theme, not in Judge.me, so they will not
     appear in Judge.me's own widgets or in Google's review snippets, and they
     go away if the stock widget is ever restored.

     Checked 23 Sep 2026: across Cocoa, Midnight and Almond only those two
     Judge.me replies exist, so nothing else on the page gains a reply box. */
  var REPLIES = {
    // Anonymous, 02 Aug - "wish I would've sized up ... it's so hard to put on"
    '494e1886-2ab2-4a1c-98c6-63e293002e9b':
      "Thank you for your review! We have since sized up all our garments, so the bodysuits now fit true to size and are a lot easier to get on.",
    // Savannah D.b., 23 May - "I would not size down ... it didn't fit"
    '6fdae0b8-797c-4f9d-a897-ebac7183696e':
      "Hi Savannah, thank you for your review, we are so glad that we managed to organise the exchange for you! We have since sized up all our garments, so the bodysuits now fit true to size.",
    // Carla L., 10 May - "I like it but was a little tight for me"
    '68f6378f-a654-4832-b621-e7c863c13ce4':
      "Hi Carla, thank you for your review! We have since sized up all our garments, so the bodysuits now fit true to size and shouldn't feel tight."
  };

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  /* Reply styling lives here so the block file does not have to be rewritten
     for it.

     Solid brand brown, #4D3736 - the theme's colour scheme 1, the header and
     the Judge.me primary. Chosen over a tint on 23 Sep: a pale wash sat too
     close to the white card and the reply read as another paragraph of the
     review, whereas the solid brown reads as the shop speaking and makes the
     answered reviews findable at a glance down the page. Its text colours are
     set explicitly, never inherited, because the card's own scheme would put
     dark text on this dark ground.

     The label wraps to two lines in a narrow desktop column, so the arrow is
     pinned to the top and nudged onto the first line's baseline rather than
     centred against both lines. */
  function injectCss() {
    if (document.getElementById('sr-reply-css')) return;
    var s = document.createElement('style');
    s.id = 'sr-reply-css';
    s.textContent =
      '.sr-card .sr-reply{margin:10px 0 0;padding:11px 12px;border-radius:10px;' +
        'background:#4D3736;}' +
      '.sr-card .sr-reply-who{display:flex;align-items:flex-start;gap:5px;margin:0 0 4px;' +
        'font-size:10px;font-weight:600;letter-spacing:.08em;line-height:1.35;' +
        'text-transform:uppercase;color:#E8DFDD;}' +
      '.sr-card .sr-reply-who svg{flex:0 0 auto;margin-top:2px;}' +
      '.sr-card .sr-reply-body{margin:0;font-size:13px;line-height:1.5;color:#FFFFFF;}' +
      // Review photos are clickable - they open the full image in the lightbox.
      '.sr-card .sr-pics img{cursor:zoom-in;}' +
      // Reply is collapsed behind this toggle so an answered card is not twice
      // as tall as the review it answers. Brand brown, pill, matches the block.
      '.sr-card .sr-reply-toggle{align-self:flex-start;display:inline-flex;align-items:center;' +
        'gap:6px;margin:2px 0 0;padding:7px 12px;border:1px solid rgba(77,55,54,.22);' +
        'border-radius:100px;background:transparent;cursor:pointer;font-family:inherit;' +
        'font-size:12px;font-weight:600;line-height:1;color:#4D3736;' +
        'transition:border-color .2s ease,background .2s ease;}' +
      '.sr-card .sr-reply-toggle:hover{border-color:#4D3736;}' +
      '.sr-card .sr-reply-toggle svg{flex:0 0 auto;}' +
      '.sr-card .sr-reply[hidden]{display:none;}' +
      // Full-screen photo viewer, built once and reused. Above the sticky bar
      // and the pay-later sheet. Click the backdrop, the close button or Esc.
      '.sr-lightbox{position:fixed;inset:0;z-index:100050;background:rgba(12,9,8,.9);' +
        'display:none;align-items:center;justify-content:center;padding:24px;cursor:zoom-out;}' +
      '.sr-lightbox.open{display:flex;}' +
      '.sr-lightbox img{max-width:100%;max-height:100%;border-radius:10px;' +
        'box-shadow:0 10px 40px rgba(0,0,0,.5);cursor:default;}' +
      '.sr-lightbox-close{position:absolute;top:16px;right:16px;width:42px;height:42px;' +
        'border:0;border-radius:999px;background:rgba(255,255,255,.16);color:#fff;' +
        'font-size:20px;line-height:1;cursor:pointer;display:grid;place-items:center;}' +
      '.sr-lightbox-close:hover{background:rgba(255,255,255,.3);}' +
      // Bigger review thumbnails. !important because the block styles these
      // through an ID-scoped rule that would otherwise win on specificity.
      '.sr-card .sr-pics{gap:7px;}' +
      '.sr-card .sr-pics img{width:72px !important;height:72px !important;}' +
      // The review text is clamped to four lines so the photos, product, name
      // and reply toggle line up across the three columns; a short review keeps
      // the four-line height as blank space. Show more lifts the clamp per card.
      '.sr-card .sr-body.sr-clamp{display:-webkit-box;-webkit-box-orient:vertical;' +
        '-webkit-line-clamp:4;overflow:hidden;}' +
      // Reserve the four-line height only where cards sit side by side (desktop),
      // so a short review lines up with its neighbours. On a phone the grid is
      // one column, so there is nothing to line up with and the padding would
      // just be wasted blank space.
      '@container (min-width: 520px){.sr-card .sr-body.sr-clamp{min-height:calc(1.6em * 4);}}' +
      '.sr-card .sr-body.sr-expanded{display:block;-webkit-line-clamp:none;' +
        'overflow:visible;min-height:0;}' +
      '.sr-card .sr-more-link{align-self:flex-start;margin:2px 0 0;padding:0;border:0;' +
        'background:none;font-family:inherit;font-size:12.5px;font-weight:600;' +
        'color:#4D3736;cursor:pointer;text-decoration:underline;text-underline-offset:3px;' +
        'text-decoration-color:rgba(77,55,54,.4);}' +
      '.sr-card .sr-more-link:hover{text-decoration-color:#4D3736;}' +
      // A review that already fits four lines needs no toggle. On desktop the
      // slot is kept but made invisible so the rows below still line up; on a
      // phone, with no neighbours to align to, it is removed entirely.
      '.sr-card .sr-more-link.sr-fit{visibility:hidden;}' +
      '@container (max-width: 519px){.sr-card .sr-more-link.sr-fit{display:none;}}';
    document.head.appendChild(s);
  }

  // The little reply arrow beside "… replied". Inline so it takes the label's
  // colour; an emoji or an image would not.
  function replyIcon() {
    var NS = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('width', '11');
    svg.setAttribute('height', '11');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '2.4');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    svg.setAttribute('aria-hidden', 'true');
    var arm = document.createElementNS(NS, 'polyline');
    arm.setAttribute('points', '9 10 4 15 9 20');
    var hook = document.createElementNS(NS, 'path');
    hook.setAttribute('d', 'M20 4v7a4 4 0 0 1-4 4H4');
    svg.appendChild(arm);
    svg.appendChild(hook);
    return svg;
  }

  /* One lightbox for the whole page, created the first time a photo is opened.
     The review photos are small by design; this is how a shopper actually sees
     what the garment looks like on someone, so it loads the ORIGINAL. */
  var lightbox = null;
  function closeLightbox() {
    if (!lightbox) return;
    lightbox.classList.remove('open');
    document.body.style.overflow = '';
  }
  function openLightbox(src) {
    if (!src) return;
    if (!lightbox) {
      lightbox = el('div', 'sr-lightbox');
      var big = el('img');
      big.alt = '';
      var close = el('button', 'sr-lightbox-close', '\u00d7');
      close.type = 'button';
      close.setAttribute('aria-label', 'Close');
      lightbox.appendChild(big);
      lightbox.appendChild(close);
      lightbox._img = big;
      lightbox.addEventListener('click', function (e) {
        if (e.target === lightbox || e.target === close) closeLightbox();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeLightbox();
      });
      document.body.appendChild(lightbox);
    }
    lightbox._img.src = src;
    lightbox.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  /* Review bodies are clamped to four lines so every card's photos, product,
     name and reply line up. A body that overflows four lines gets a Show more
     / Show less toggle; the registry re-measures on resize, because the column
     width - and so how many lines the text wraps to - changes between phone
     (one column) and desktop (three). */
  var clampRegistry = [];
  var clampResizeBound = false;
  function measureClamp(entry) {
    if (entry.expanded) return;
    var overflow = entry.body.scrollHeight > entry.body.clientHeight + 1;
    entry.btn.classList.toggle('sr-fit', !overflow);
    entry.btn.disabled = !overflow;
  }
  function registerClamp(entry) {
    clampRegistry.push(entry);
    if (!clampResizeBound) {
      clampResizeBound = true;
      var t;
      window.addEventListener('resize', function () {
        clearTimeout(t);
        t = setTimeout(function () { clampRegistry.forEach(measureClamp); }, 150);
      });
    }
  }

  function reviewText(r) {
    if (r.body) return String(r.body);
    if (!r.body_html || !parser) return '';
    // Paragraph and line breaks become spaces so sentences don't run together.
    var html = String(r.body_html).replace(/<\s*(br|\/p|\/div|\/li)\b[^>]*>/gi, ' $&');
    return parser.parseFromString(html, 'text/html').body.textContent || '';
  }

  /* An override wins over whatever Judge.me holds. Judge.me's own replies are
     sent as HTML (a <p>, sometimes a mailto link), so they go through the same
     inert parse as the review bodies and are written with textContent. */
  function replyText(r) {
    var override = r.uuid && REPLIES[r.uuid];
    if (override) return override;
    var raw = r.reply_content || r.reply || '';
    if (!raw) return '';
    raw = String(raw);
    if (raw.indexOf('<') === -1 || !parser) return raw.replace(/\s+/g, ' ').trim();
    var html = raw.replace(/<\s*(br|\/p|\/div|\/li)\b[^>]*>/gi, ' $&');
    var text = parser.parseFromString(html, 'text/html').body.textContent || '';
    return text.replace(/\s+/g, ' ').trim();
  }

  function starRow(rating) {
    var wrap = el('span', 'sr-stars sm');
    wrap.setAttribute('aria-label', rating + ' out of 5');
    for (var i = 1; i <= 5; i++) {
      wrap.appendChild(el('span', 'sr-star' + (i <= rating ? ' on' : ''), '★'));
    }
    return wrap;
  }

  function formatDate(iso) {
    var d = new Date(iso);
    if (isNaN(d)) return '';
    var day = ('0' + d.getDate()).slice(-2);
    return day + ' ' + MONTHS[d.getMonth()] + ' ' + d.getFullYear();
  }

  function truncate(text, max) {
    text = String(text || '').replace(/\s+/g, ' ').trim();
    if (!max || text.length <= max) return text;
    var cut = text.slice(0, max);
    var space = cut.lastIndexOf(' ');
    return (space > max * 0.6 ? cut.slice(0, space) : cut) + '…';
  }

  function card(r, cfg, products) {
    var a = el('article', 'sr-card');
    a.appendChild(starRow(r.rating));
    if (r.title) a.appendChild(el('p', 'sr-title', r.title));
    var bodyText = reviewText(r).replace(/\s+/g, ' ').trim();
    if (bodyText) {
      var body = el('p', 'sr-body sr-clamp', bodyText);
      a.appendChild(body);

      /* The toggle sits on its own line below the text and is ALWAYS in the
         DOM so the slot is the same height on every card; it is only made
         invisible when the review already fits in four lines. */
      var moreBtn = el('button', 'sr-more-link sr-fit', 'Show more');
      moreBtn.type = 'button';
      var clamp = { body: body, btn: moreBtn, expanded: false };
      moreBtn.addEventListener('click', function () {
        clamp.expanded = !clamp.expanded;
        body.classList.toggle('sr-expanded', clamp.expanded);
        moreBtn.textContent = clamp.expanded ? 'Show less' : 'Show more';
      });
      a.appendChild(moreBtn);
      registerClamp(clamp);
      requestAnimationFrame(function () { measureClamp(clamp); });
    }

    var pics = (r.pictures_urls || []).slice(0, 3);
    if (pics.length) {
      var box = el('div', 'sr-pics');
      pics.forEach(function (p) {
        var src = p.small || p.compact || p.original;
        if (!src) return;
        var full = p.original || p.compact || p.small || src;
        var img = el('img');
        img.src = src;
        img.alt = '';
        img.loading = 'lazy';
        img.setAttribute('role', 'button');
        img.setAttribute('tabindex', '0');
        img.setAttribute('aria-label', 'View review photo');
        img.addEventListener('click', function () { openLightbox(full); });
        img.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLightbox(full); }
        });
        box.appendChild(img);
      });
      a.appendChild(box);
    }

    // Which colourway this review is about.
    var prod = products && products[r.shapedProductId];
    if (prod && prod.n) {
      var row = el('p', 'sr-prod');
      if (prod.i) {
        var pim = el('img');
        pim.src = prod.i;
        pim.alt = '';
        pim.width = 26;
        pim.height = 34;
        pim.loading = 'lazy';
        row.appendChild(pim);
      }
      row.appendChild(el('span', null, prod.n));
      a.appendChild(row);
    }

    var meta = el('p', 'sr-meta');
    meta.appendChild(el('b', null, r.reviewer_name || 'Anonymous'));
    meta.appendChild(document.createTextNode(' '));
    meta.appendChild(el('span', 'sr-ver', '✓ ' + cfg.verified));
    meta.appendChild(el('br'));
    meta.appendChild(document.createTextNode(formatDate(r.created_at)));
    a.appendChild(meta);

    /* The shop's reply, last, so it reads as the answer to the review above
       it. Never truncated: the replies are short and they are the correction
       to reviews that would otherwise mislead. */
    var reply = replyText(r);
    if (reply) {
      var whoName = r.shop_reply_name || cfg.brand || 'Shaped Collection';

      /* Collapsed by default: the reply box is as tall as the review, so left
         open it doubled every answered card. The toggle says who replied, and
         opening it shows the box below. */
      var toggleBtn = el('button', 'sr-reply-toggle');
      toggleBtn.type = 'button';
      toggleBtn.setAttribute('aria-expanded', 'false');
      toggleBtn.appendChild(replyIcon());
      var toggleLabel = el('span', null, 'View reply from ' + whoName);
      toggleBtn.appendChild(toggleLabel);

      var rep = el('div', 'sr-reply');
      rep.hidden = true;
      var who = el('b', 'sr-reply-who');
      who.appendChild(replyIcon());
      who.appendChild(el('span', null, whoName + ' replied'));
      rep.appendChild(who);
      rep.appendChild(el('p', 'sr-reply-body', reply));

      toggleBtn.addEventListener('click', function () {
        var open = rep.hidden;
        rep.hidden = !open;
        toggleBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        toggleLabel.textContent = open ? 'Hide reply' : ('View reply from ' + whoName);
      });

      a.appendChild(toggleBtn);
      a.appendChild(rep);
    }

    return a;
  }

  function fetchProduct(shop, id) {
    var all = [];
    function page(n) {
      var url = ENDPOINT + '?url=' + encodeURIComponent(shop)
        + '&shop_domain=' + encodeURIComponent(shop)
        + '&platform=shopify&per_page=' + PER_REQUEST
        + '&page=' + n + '&product_id=' + encodeURIComponent(id);
      return fetch(url).then(function (res) {
        if (!res.ok) throw new Error('judge.me ' + res.status);
        return res.json();
      }).then(function (json) {
        var revs = json.reviews || [];
        // Remember which product this page was fetched under: the endpoint's
        // own product fields are not dependable, and the card has to name it.
        revs.forEach(function (r) { r.shapedProductId = String(id); });
        all = all.concat(revs);
        var pages = (json.pagination && json.pagination.total_pages) || 1;
        if (revs.length && n < pages && n < MAX_PAGES) return page(n + 1);
        return all;
      });
    }
    return page(1);
  }

  function rebuildHistogram(root, reviews) {
    var bars = root.querySelectorAll('.sr-bar');
    if (!bars.length || !reviews.length) return;
    var counts = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
    reviews.forEach(function (r) { if (counts[r.rating] != null) counts[r.rating]++; });
    bars.forEach(function (bar) {
      var label = bar.querySelector('.sr-bar-n');
      var rating = label ? parseInt(label.textContent, 10) : NaN;
      if (!counts.hasOwnProperty(rating)) return;
      var pct = Math.round(counts[rating] / reviews.length * 100);
      var fill = bar.querySelector('.sr-bar-fill');
      var p = bar.querySelector('.sr-bar-p');
      if (fill) fill.style.width = pct + '%';
      if (p) p.textContent = pct + '%';
    });
  }

  /* The score, the stars and the count beside them, from the same merged list
     the histogram uses. Before this the headline came from the shop-wide
     Judge.me metafields, so a product with a handful of reviews showed the
     shop's average over a chart of its own - see the note at the top.

     Also updates the rating line beside the price, so the page never shows two
     different numbers for the same thing. That line is server-rendered from
     whatever its own "Rating scope" setting says; this overwrites it once the
     real numbers are in. If it should keep showing the shop-wide figure, take
     the .sph-rate part out rather than changing the block setting, or the two
     will disagree again.

     The scope wording ("across Shaped Collection") is removed with it: it was
     only true of the shop-wide number. */
  function applySummary(root, reviews) {
    if (!reviews.length) return;

    var total = 0;
    reviews.forEach(function (r) { total += (+r.rating || 0); });
    var avg = total / reviews.length;
    var avgTxt = avg.toFixed(1);
    var whole = Math.round(avg);
    var countTxt = reviews.length + (reviews.length === 1 ? ' review' : ' reviews');

    var avgEl = root.querySelector('.sr-avg');
    if (avgEl) avgEl.textContent = avgTxt;

    var scoreStars = root.querySelector('.sr-score .sr-stars');
    if (scoreStars) {
      scoreStars.setAttribute('aria-label', avgTxt + ' out of 5');
      var stars = scoreStars.querySelectorAll('.sr-star');
      for (var i = 0; i < stars.length; i++) {
        if (i < whole) stars[i].classList.add('on');
        else stars[i].classList.remove('on');
      }
    }

    var countEl = root.querySelector('.sr-count');
    if (countEl) countEl.textContent = countTxt;

    var rateText = document.querySelector('.sph-rate-text');
    if (rateText) {
      var b = rateText.querySelector('b');
      var u = rateText.querySelector('u');
      if (b) b.textContent = avgTxt;
      if (u) u.textContent = countTxt;
    }
    var sphStars = document.querySelectorAll('.sph-rate .sph-star');
    for (var j = 0; j < sphStars.length; j++) {
      if (j < whole) sphStars[j].classList.add('on');
      else sphStars[j].classList.remove('on');
    }
  }

  function readProducts(root) {
    var tag = root.querySelector('.sr-products');
    if (!tag) return null;
    try { return JSON.parse(tag.textContent); } catch (e) { return null; }
  }

  function init(root) {
    if (root.dataset.srReady === '1') return;
    root.dataset.srReady = '1';

    var cfg;
    try { cfg = JSON.parse(root.getAttribute('data-sr-config')); } catch (e) { return; }
    if (!cfg || !cfg.shop || !cfg.ids || !cfg.ids.length) return;

    injectCss();

    /* One column on a phone, three from 520px: the batch sizes follow, so a
       phone shows four cards rather than six and adds four at a time. */
    var onPhone = window.matchMedia('(max-width: 749px)').matches;
    var perClick = (onPhone && cfg.perM) || cfg.per || 3;
    var firstCount = (onPhone && cfg.firstM) || cfg.first || perClick;
    var products = readProducts(root);

    var grid = root.querySelector('.sr-cards');
    var more = root.querySelector('.sr-more');
    var less = root.querySelector('.sr-less');

    Promise.all(cfg.ids.map(function (id) { return fetchProduct(cfg.shop, id); }))
      .then(function (lists) {
        var seen = {};
        var merged = [];
        lists.forEach(function (list) {
          list.forEach(function (r) {
            var key = r.uuid || (r.reviewer_name + r.created_at);
            if (seen[key]) return;
            seen[key] = true;
            merged.push(r);
          });
        });
        merged.sort(function (a, b) { return new Date(b.created_at) - new Date(a.created_at); });

        rebuildHistogram(root, merged);
        applySummary(root, merged);

        var visible = merged.filter(function (r) { return r.rating >= cfg.min; });
        if (!visible.length) return;

        /* Reviews WITH photos first, newest within each group. The merged list
           is already newest-first, but sorting on the date too keeps the order
           correct regardless of sort stability. The histogram and the summary
           above are built from the full merged list, so this only reorders the
           cards. */
        visible.sort(function (a, b) {
          var pa = (a.pictures_urls && a.pictures_urls.length) ? 1 : 0;
          var pb = (b.pictures_urls && b.pictures_urls.length) ? 1 : 0;
          if (pa !== pb) return pb - pa;
          return new Date(b.created_at) - new Date(a.created_at);
        });

        if (!grid) {
          grid = el('div', 'sr-cards');
          root.insertBefore(grid, root.querySelector('.sr-buttons') || more || null);
        }
        grid.textContent = '';

        var shown = 0;
        function buttons() {
          if (more) more.hidden = shown >= visible.length;
          // Nothing to collapse until more than the first batch is on screen.
          if (less) less.hidden = shown <= firstCount;
        }
        function showNext(count) {
          var end = Math.min(shown + count, visible.length);
          for (var i = shown; i < end; i++) grid.appendChild(card(visible[i], cfg, products));
          shown = end;
          buttons();
        }
        function collapse() {
          while (grid.children.length > firstCount) grid.removeChild(grid.lastChild);
          shown = Math.min(firstCount, visible.length);
          buttons();
          // Land at the top of the section, not halfway down a shorter page.
          root.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
        showNext(firstCount);

        if (more) more.addEventListener('click', function () { showNext(perClick); });
        if (less) less.addEventListener('click', collapse);
      })
      .catch(function () { /* keep the server-rendered cards */ });
  }

  function boot() {
    document.querySelectorAll('.sr[data-sr-config]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();